module.exports = __webpack_public_path__ + "./fonts/Aino-Headline.otf";